import styled from 'styled-components'

export const Container = styled.div`
  border-radius: 4px;
  position: relative;
  margin: 8px 0;
`
